import React from 'react';
import { Row } from 'react-table';
import { ExecutedRow } from './ExecutionTableUtils';
import { IBalanceInstruction } from '../../../../../../sp-types/balanceFlowType';
import { EditExecuteRow } from './EditExecuteRow';

interface TableBodyProps {
  rows: Row<IBalanceInstruction>[];
  prepareRow: (_row: Row<IBalanceInstruction>) => void;
  getTableBodyProps: () => any;
  onUpdateExecution?: (_instrument: string, _contractCount?: number, _price?: number) => void;
  isShowExecuted: boolean;
}
export const ExecutionTableBody: React.FC<TableBodyProps> = ({
  rows,
  prepareRow,
  getTableBodyProps,
  onUpdateExecution,
  isShowExecuted,
}) => {
  const getGrayTotalCell = (cell: any) =>
    isShowExecuted && ['Quantity', 'Total Price'].includes(cell.column.id) ? ' text-gray-450' : '';

  return (
    <tbody {...getTableBodyProps()} className="overflow-y-auto ">
      {rows.map((row) => {
        prepareRow(row);
        return (
          <React.Fragment key={row.id}>
            <tr
              {...row.getRowProps()}
              key={'r' + row.id}
              className="bg-white whitespace-nowrap  overflow-auto text-ellipsis border border-gray-100"
            >
              {row.cells.map((cell) => (
                <td
                  {...cell.getCellProps()}
                  className={
                    `font-medium text-sm py-[0.5rem] ps-[1rem] border border-gray-200 ` + getGrayTotalCell(cell)
                  }
                  key={cell.column.id}
                >
                  {cell.render('Cell')}
                </td>
              ))}
            </tr>
            {!isShowExecuted && row.original.status === 'executed' && <ExecutedRow row={row} />}
            {isShowExecuted && <EditExecuteRow row={row} onUpdateExecution={onUpdateExecution} />}
          </React.Fragment>
        );
      })}
    </tbody>
  );
};
